import styled from "styled-components";

export const Container = styled.aside`  

  /* justify-content: center; */
  flex-grow: 20;
  flex-shrink: 0;
  /* background: #; */
  /* padding: 120px 80px; */
  display: none;
  /* background: blue; */

  @media (min-width: 1140px) {
      /* display: flex; */
      /* background-color: #45cc94; */
      display: flex;
      align-items: center;
  }

  @media (min-width: 1440px) {
      align-items: initial;
    
  }

  > img {
    background-size: cover;
    /* margin-left: -11em; */
    width: 60%;
    flex-shrink: 0;
    margin-left: -5em;
    /* margin-top: -5em; */
    position: absolute;

  }

  #shadown{
    background-size: cover;
    width: 60%;

    /* margin-left: -11em; */
    margin-left: -3em;
    /* margin-top: -2em; */
    border-radius: 8px;
    filter: blur(30px);    

  }
`;